import { render, staticRenderFns } from "./SocialLoginValidation.vue?vue&type=template&id=b54a263e&"
import script from "./SocialLoginValidation.vue?vue&type=script&lang=js&"
export * from "./SocialLoginValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports